import React from "react";
import { CircularProgress, Backdrop } from "@mui/material";

const LoadingIndicator = () => {
  return (
    <Backdrop
      open={true}
      sx={(theme) => ({
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
      })}
    >
      <CircularProgress color="inherit" size={60} aria-label="Loading" />
    </Backdrop>
  );
};

export default LoadingIndicator;
